export { default } from './FormKioskBannerType.vue'
